import Styles from './menuAddonCard.module.scss';

export const MenuAddonCard = ({
	type,
	title,
	items,
	columns,
	footnote,
	variant = 'panel'
}) => {
	const isInline = variant === 'inline';

	return (
		<div className={isInline ? Styles.inlineCard : Styles.card}>
			<h4 className={isInline ? Styles.inlineTitle : Styles.title}>{title}</h4>
			{type === 'list' && (
				<ul className={isInline ? Styles.inlineList : Styles.list}>
					{items.map((item) => (
						<li key={item.label} className={isInline ? Styles.inlineListItem : Styles.listItem}>
							<span>{isInline ? item.label : `+ ${item.label}`}</span>
							<span>{item.price}{item.priceNote}</span>
						</li>
					))}
				</ul>
			)}
			{type === 'grid' && (
				<div className={Styles.grid}>
					{columns.map((column) => (
						<div key={column.join('-')} className={Styles.gridColumn}>
							{column.map((entry) => <span key={entry}>{entry}</span>)}
						</div>
					))}
				</div>
			)}
			{footnote && <p className={Styles.footnote}>{footnote}</p>}
		</div>
	);
};
